import React from 'react';
import { Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export type NewDeleteModalProps<T> = {
  children: React.ReactNode;

  deleting: boolean;
  obj?: T;
  onOk: () => void;
  onCancel: () => void;
  okLabel?: string;
};

export function NewDeleteModal<T>(props: NewDeleteModalProps<T>) {
  return (
    <Modal
      zIndex={2000}
      title="Confirmation"
      visible={props.obj !== undefined}
      onOk={props.onOk}
      okText={props.okLabel ?? 'Delete'}
      okButtonProps={{
        danger: true,
        disabled: props.deleting,
        icon: props.deleting ? <LoadingOutlined /> : null,
      }}
      onCancel={props.onCancel}
      cancelButtonProps={{
        className: 'float-left',
        disabled: props.deleting,
      }}
    >
      {props.children}
    </Modal>
  );
}
